import Model from '@/models/Model'

export default class WhDispatchGuide extends Model {
    resource() {
        return 'wh_dispatch_guide'
    }
}